// eslint-disable-next-line no-shadow
export enum Actions {
  SET_DEPLOY_RELEASE_MODAL_UNFETCHED_NEW_RELEASE = 'SET_DEPLOY_RELEASE_MODAL_UNFETCHED_NEW_RELEASE'
}

export interface ReleaseAction {
  type: Actions.SET_DEPLOY_RELEASE_MODAL_UNFETCHED_NEW_RELEASE
  payload: boolean
}
